import { Bell, CircleCheck, Info, Link, RotateCcw, Send, Undo2 } from "lucide-react";
import { toast } from "sonner";

type Icon = "check" | "bell" | "send" | "info" | "link" | "rework";

/** Тосты раздела живут в своём контейнере — сверху по центру, не над кнопками модалок. */
export const MONTAGE_TOASTER = "montage";

const ICONS = {
  check: <CircleCheck className="size-[18px] text-done" />,
  bell: <Bell className="size-[18px] text-wait" />,
  send: <Send className="size-[18px] text-work" />,
  info: <Info className="size-[18px] text-ring" />,
  link: <Link className="size-[18px] text-ring" />,
  rework: <RotateCcw className="size-[18px] text-rework" />,
};

/**
 * Тост-«таблетка» с «Отменить» и тающей полоской (M4).
 *
 * `action` — своя кнопка рядом («Показать», «Сдать»): то, что человеку,
 * скорее всего, нужно следующим шагом.
 */
export function notify(text: string, opts: { icon?: Icon; undo?: () => void; action?: { label: string; run: () => void }; duration?: number } = {}) {
  const duration = opts.duration ?? (opts.undo || opts.action ? 5000 : 3200);
  toast.custom(
    (id) => (
      <div className="pointer-events-none relative flex h-[52px] min-w-[300px] max-w-[560px] items-center gap-3 overflow-hidden rounded-full bg-primary pl-[18px] pr-2 text-primary-foreground shadow-mlg">
        {ICONS[opts.icon ?? "check"]}
        <span className="flex-1 truncate text-sm font-medium">{text}</span>
        {opts.action && (
          <button
            type="button"
            onClick={() => {
              opts.action?.run();
              toast.dismiss(id);
            }}
            className="pointer-events-auto inline-flex h-9 items-center rounded-full bg-white/15 px-3.5 text-[13px] font-medium transition-colors hover:bg-white/25"
          >
            {opts.action.label}
          </button>
        )}
        {opts.undo ? (
          <button
            type="button"
            onClick={() => {
              opts.undo?.();
              toast.dismiss(id);
            }}
            className="pointer-events-auto inline-flex h-9 items-center gap-1.5 rounded-full border border-white/25 px-3.5 text-[13px] font-medium transition-colors hover:bg-white/10"
          >
            <Undo2 className="size-3.5" />
            Отменить
          </button>
        ) : (
          !opts.action && <span className="w-2" />
        )}
        <span
          className="countdown-bar absolute bottom-0 left-6 right-6 h-[2px] rounded-full bg-white/35"
          style={{ animationDuration: `${duration}ms` }}
        />
      </div>
    ),
    { duration, toasterId: MONTAGE_TOASTER },
  );
}
